import { isValidCategoryPage } from 'product-landing-pages/utils/isValidCategoryPage';
import { ParsedUrlQuery } from 'querystring';
import { PDP_SUBCATEGORIES } from 'shared/enums/category';

export const isPdpPage = (url: string, query: ParsedUrlQuery = {}) => {
  if (Object.keys(query)?.length !== 2) {
    const splitURL = url?.split('/');
    const lengthOfURL = splitURL?.length || 0;

    if (lengthOfURL !== 3) {
      return false;
    }

    const isPDPbasePath = splitURL[1] === 'sneakers' || splitURL[1] === 'apparel';
    const productSlug = splitURL[lengthOfURL - 1];
    const productSlugNotSubCategory = !PDP_SUBCATEGORIES.has(productSlug);

    return isPDPbasePath && productSlugNotSubCategory;
  }

  const productType = query?.pageSlug as string;
  const subType = query?.productSlug as string;
  const isCategoryPage = isValidCategoryPage({ productType, subType, groups: [] });

  return query?.pageSlug && query?.productSlug && !isCategoryPage;
};
